/* Shared micro-motion for the send-message choreography. Every rule lives
   behind prefers-reduced-motion: no-preference, so reduced-motion readers get
   the same instant transitions the chat shipped with before these classes. */

/* A just-sent message rising into its transcript slot. Applied only to
   pending occurrences: committed rows remount whenever the virtualizer
   scrolls them back into view, and a mount animation there would replay on
   every scroll. */
@keyframes phoebe-chat-rise {
    from {
        opacity: 0;
        transform: translateY(8px) scale(0.98);
    }
}

@media (prefers-reduced-motion: no-preference) {
    .phoebe-chat-rise {
        animation: phoebe-chat-rise 180ms cubic-bezier(0.22, 1, 0.36, 1) both;
    }

    .phoebe-save-note-line {
        stroke-dasharray: 13;
        stroke-dashoffset: 13;
    }

    .phoebe-save-note-icon .phoebe-save-note-line:first-of-type {
        animation: phoebe-save-note-write-line 560ms
            cubic-bezier(0.16, 1, 0.3, 1) 120ms forwards;
    }

    .phoebe-save-note-icon .phoebe-save-note-line + .phoebe-save-note-line {
        animation: phoebe-save-note-write-line 560ms
            cubic-bezier(0.16, 1, 0.3, 1) 520ms forwards;
    }

    .phoebe-save-note-pen {
        transform-origin: 15px 8px;
        animation: phoebe-save-note-pen-write 1.2s cubic-bezier(0.16, 1, 0.3, 1)
            both;
    }
}

@keyframes phoebe-save-note-write-line {
    to {
        stroke-dashoffset: 0;
    }
}

@keyframes phoebe-save-note-pen-write {
    0% {
        transform: translate(-1px, 2px) rotate(-7deg);
    }
    34% {
        transform: translate(-0.45px, 0.8px) rotate(-3deg);
    }
    65% {
        transform: translate(0.05px, 0) rotate(0deg);
    }
    100% {
        transform: translate(1px, -1px) rotate(3deg);
    }
}
